export const notifications = {
  p1: `NUEVO CHECK-IN`,
  p2: `completo el check-in con éxito`,
  p3: `NUEVA SOLICITUD DE SERVICIO`,
  p4: `ha solicitado `,
  p5: ``,
  p6: ``,
  p7: ``,
  p8: ``,

  booking: {
    new: {
      title: "Nueva reserva",
      body: "Se ha creado una nueva reserva."
    },
    update: {
      title: "Reserva actualizada",
      body: "Se ha actualizado una reserva."
    },
    cancelled: {
      title: "Reserva cancelada",
      body: "Se ha cancelado una reserva."
    },
    request_created: {
      title: "Nueva solicitud de reserva",
      body: "Un huésped ha enviado una solicitud de reserva."
    },
    request_approved: {
      title: "Solicitud de reserva aprobada",
      body: "Se ha aprobado una solicitud de reserva."
    },
    request_rejected: {
      title: "Solicitud de reserva rechazada",
      body: "Se ha rechazado una solicitud de reserva."
    }
  },

  types: {
    booking_new: "Nueva Reserva",
    booking_update: "Reserva Actualizada",
    booking_cancel: "Reserva Cancelada",
    booking_request: "Solicitud",
    booking_request_approved: "Solicitud Aprobada",
    booking_request_rejected: "Solicitud Rechazada",
    checkin: "Check-in",
    service: "Servicio"
  }
};
